var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['burger', {'burger_active': _vm.active}, {'burger_inverse': _vm.inverse}],attrs:{"aria-label":"Menu"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"burger__icon"},[_c('span',{staticClass:"line-1"}),_c('span',{staticClass:"line-2"}),_c('span',{staticClass:"line-3"}),_c('span',{staticClass:"line-4"})])
}]

export { render, staticRenderFns }